import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { revenue: { getRevenue } } = apiUrls;

export const REVENUE_DETAILS_SUCCESS = 'REVENUE_DETAILS_SUCCESS';
export const REVENUE_DETAILS_LOADING = 'REVENUE_DETAILS_LOADING';

export const getRevenueData = ({ vendor }) => async (dispatch) => {
  const apiData = getRevenue;

  try {
    const { url } = apiData;

    if (vendor) {
      const requestData = {
        ...apiData,
        url: url.replace('{{vendor}}', vendor)
      };
      const data = await REQUEST(requestData);
      dispatch({
        type: REVENUE_DETAILS_SUCCESS,
        data,
        vendor
      })
    }

  } catch (e) {

    dispatch({
      type: REVENUE_DETAILS_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      },
      vendor
    })
  }
}

export const handleLoader = (isLoading, vendor) => (dispatch) => {

  if (vendor) {
    dispatch({
      type: REVENUE_DETAILS_LOADING,
      isLoading,
      vendor
    })
  }
}
